type UseGetPaginationProps = {
  count?: number;
  currentPage: number;
  onPageChange: (page: number) => void;
};

export const useGetPagination = ({ count, onPageChange, currentPage }: UseGetPaginationProps) => {
  const PAGE_SIZE = 50;
  const PaginationBar = count && (
    <div className="flex justify-center space-x-3 mt-4">
      {/* <button
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
        className="px-2 py-1 text-cyan-700">
        Previous
      </button> */}
      {Array.from({ length: Math.ceil(count / PAGE_SIZE) }).map((_, index) => (
        <button
          key={index}
          onClick={() => onPageChange(index + 1)}
          className={`px-2 py-1 border border-cyan-700 text-black rounded rounded-full w-[2rem] h-[2rem] ${
            index + 1 === currentPage ? 'bg-cyan-700 text-white' : ''
          }`}>
          {index + 1}
        </button>
      ))}
      {/* <button
        disabled={currentPage === Math.ceil(count / PAGE_SIZE)}
        onClick={() => onPageChange(currentPage + 1)}
        className="px-2 py-1 text-cyan-700">
        Next
      </button> */}
    </div>
  );

  return { PaginationBar };
};
